import { APP_BASENAME } from '../appPaths';

/** Prefix `/public` asset paths when hosted under a CRA subpath (`PUBLIC_URL`). */
export function publicAssetPath(path: string): string {
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return APP_BASENAME ? `${APP_BASENAME}/${normalized}` : `/${normalized}`;
}
